export const TEMPLATE_TYPES = ["email", "sms", "push_notification", "document"] as const;

export const TEMPLATE_STATUS = ["draft", "published"] as const;

export const LOCALES = [
  "en-US",
  "fr-FR",
  "es-ES",
  "de-DE",
  "zh-CN",
  "ja-JP",
  "ru-RU",
  "ro-RO",
] as const;

export const USER_ROLES = ["user", "admin"] as const;
export const ADMIN_USER_ROLES_FILTER = ["all", ...USER_ROLES] as const;
